import { render, staticRenderFns } from "./TravelOrderList.vue?vue&type=template&id=0f4e4fde&scoped=true"
import script from "./TravelOrderList.vue?vue&type=script&lang=js"
export * from "./TravelOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e4fde",
  null
  
)

export default component.exports